'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageBannerWrapper = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = require('react-redux');

var _FullWidthBackground = require('acq-components/lib/composite-components/FullWidthBackground/FullWidthBackground');

var _Image = require('acq-components/lib/base-components/Image/Image');

var _imageBanner = require('../../redux/selectors/imageBanner');

var selectors = _interopRequireWildcard(_imageBanner);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageBannerWrapper = function ImageBannerWrapper(_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      shadeAlternator = _ref.shadeAlternator,
      namespace = _ref.namespace,
      _ref$useMarginTop = _ref.useMarginTop,
      useMarginTop = _ref$useMarginTop === undefined ? true : _ref$useMarginTop,
      props = (0, _objectWithoutProperties3.default)(_ref, ['styles', 'shadeAlternator', 'namespace', 'useMarginTop']);

  if (!props.src) {
    return null;
  }

  var imageStyle = {
    width: '100%'
  };

  return _react2.default.createElement(
    _FullWidthBackground.FullWidthBackground,
    {
      styles: styles.fullWidthBackground,
      isDarkShade: shadeAlternator.isShaded()
    },
    _react2.default.createElement(_Image.Image, {
      namespace: 'imageBanner',
      qeId: props.qeId,
      className: 'image-banner',
      alt: props.alt,
      src: props.src,
      style: imageStyle
    })
  );
};

exports.ImageBannerWrapper = ImageBannerWrapper;
var mapStateToProps = function mapStateToProps(state) {
  return {
    qeId: selectors.getQeId(state),
    alt: selectors.getAlt(state),
    src: selectors.getSrc(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ImageBannerWrapper);